import { selectComponentState } from 'projectRedux/store';
import { eppColorAdapter } from '../adapters/eppColorAdapter';

export const {
  selectAll: selectAllEppColors,
  selectById: selectEppColorById,
  selectEntities: selectEppColorEntities,
} = eppColorAdapter.getSelectors((state) => selectComponentState(state).eppColors);
